<template>
    <div class="content-wrapper">
        <div class="page-wrapper">
            <div class="nav-bar">
                <div class="logo-section">
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-md-4">
                            <a href="#">
                                <img src="../assets/logo.png"  style="height: 108px;" >
                            </a>
                            <a href="#" style="margin-left: 16px">
                                <img src="../assets/u_logo.gif"  style="height: 100px;" >
                            </a>
                        </div>
                        <div class="col-md-5 text-center">
                            <h2 style="text-align: center; color: #6C7A80;">
                                ฐานข้อมูลเห็ดพิษ
                            </h2>
                            <p style="padding-top:10px; text-align: center; color: #6C7A80;font-size: 18px;">
                                กรมวิทยาศาสตร์การแพทย์ ร่วมกับ มหาวิทยาลัยมหาสารคาม
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  module.exports = {
    name: 'web-header',
    data: function () {
      return {

      }
    }
  }
</script>


// WEBPACK FOOTER //
// WebHeader.vue?9d99db6e